import { useContext, useEffect, useState } from 'react';
import { ViContext } from '../../context/ViContext';
import Map from './Map';
import { MapContext } from '../../context/MapContext';
import { SvgIcon } from '@mui/material';
import LabelIcon from '@mui/icons-material/Label';
import { getLayersByKey } from '../../common/layer';
import Popup from '../popup/Popup';

function WeightedMap(props) {
	const { mapMode, emdCode } = useContext(ViContext);
	const {
		createMap,
		weightedMap,
		setWeightedMap,
		weightedMapLayers,
		setWeightedMapLayers,
	} = useContext(MapContext);
	const [mapTitleSize, setMapTitleSize] = useState(true);

	const handleMapZoomLevel = (handle) => {
		const value = handle === 'plus' ? 1 : -1;
		weightedMap.getView().setZoom(weightedMap.getView().getZoom() + value);
	};

	const onClickMapTit = () => {
		setMapTitleSize(!mapTitleSize);
	};

	useEffect(() => {
		const weightedLayers = getLayersByKey('weightedLayers');
		const { bgLayer: weightedBgLayer, ...weightedTargetLayers } =
			weightedLayers;
		const map = createMap('weightedMap', weightedBgLayer, weightedTargetLayers);
		setWeightedMap(map);
		setWeightedMapLayers(weightedLayers);

		return () => {
			const mapEl = document.querySelector('#weightedMap');
			if (mapEl && mapEl.hasChildNodes()) {
				mapEl.removeChild(mapEl.children[0]);
			}
			setWeightedMap(null);
		};
	}, []);

	useEffect(() => {
		if (!weightedMapLayers) return;

		if (emdCode) {
			weightedMapLayers.vi_sgg.setVisible(false);
			weightedMapLayers.vi_emd.setVisible(true);
		} else {
			weightedMapLayers.vi_emd.setVisible(false);
			weightedMapLayers.vi_sgg.setVisible(true);
		}
	}, [emdCode]);

	return (
		<div id={`${mapMode}Partition`} className={mapMode}>
			<Map id={`${mapMode}Map`} zoomHandler={handleMapZoomLevel} />
			{mapTitleSize ? (
				<div
					className={emdCode !== '' ? 'mapTit blueBG' : 'mapTit redBG'}
					onClick={(e) => {
						onClickMapTit(e);
					}}
				>
					{emdCode !== '' ? '읍면동' : '시군구'}
				</div>
			) : (
				<div
					className=" titIcon"
					onClick={(e) => {
						onClickMapTit(e);
					}}
				>
					<SvgIcon component={LabelIcon} sx={{ fontSize: 30 }}></SvgIcon>
				</div>
			)}
			<Popup type="weighted" />
		</div>
	);
}

export default WeightedMap;
